<template>
  <div class="race-program">
    <div class="race-program__header">
      <h3>Program</h3>
    </div>
    <div class="race-program__content">
      <div 
        v-for="round in program" 
        :key="round.roundIndex" 
        class="race-program__round"
        :class="{ 'race-program__round--active': round.roundIndex === currentRoundIndex }"
      >
        <div class="race-program__round-header">
          {{ round.roundNumber }}{{ getOrdinalSuffix(round.roundNumber) }} Lap - {{ round.distance }}m
        </div>
        <table class="race-program__table">
          <thead>
            <tr>
              <th>Position</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(horse, index) in round.horses" :key="horse.id">
              <td>{{ index + 1 }}</td>
              <td>{{ horse.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div v-if="program.length === 0" class="race-program__empty">
        <p>Click "Generate Program" to create a race schedule</p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { getOrdinalSuffix } from '@/utils/helpers'

export default {
  name: 'RaceProgram',
  setup() {
    const store = useStore()
    const program = computed(() => store.getters['race/raceProgram'])
    const currentRoundIndex = computed(() => store.state.race.currentRound)
    return { program, currentRoundIndex, getOrdinalSuffix }
  }
}
</script>

<style scoped>
.race-program {
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.race-program__header {
  background: linear-gradient(135deg, var(--color-warning) 0%, var(--color-warning-hover) 100%);
  color: white;
  padding: var(--space-4) var(--space-5);
  text-align: center;
  flex-shrink: 0;
}

.race-program__header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
}

.race-program__header h3::before {
  content: '📅';
  font-size: 16px;
}

.race-program__content {
  flex: 1;
  overflow-y: auto;
  padding: var(--space-3);
}

.race-program__round {
  margin-bottom: var(--space-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  overflow: hidden;
  transition: all 0.2s ease;
}

.race-program__round:last-child {
  margin-bottom: 0;
}

.race-program__round--active {
  border-color: var(--color-warning);
  box-shadow: 0 0 0 2px var(--color-warning-light);
}

.race-program__round-header {
  background-color: var(--color-warning-light);
  padding: var(--space-2) var(--space-3);
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-align: center;
  color: var(--color-warning-hover);
}

.race-program__round--active .race-program__round-header {
  background: linear-gradient(135deg, var(--color-warning) 0%, var(--color-warning-hover) 100%);
  color: white;
}

.race-program__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}

.race-program__table th,
.race-program__table td {
  padding: var(--space-1) var(--space-2);
  text-align: center;
}

.race-program__table th {
  background-color: var(--color-border-light);
  font-weight: 600;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
}

.race-program__table tbody tr {
  border-bottom: 1px solid var(--color-border-light);
  transition: background-color 0.15s ease;
}

.race-program__table tbody tr:last-child {
  border-bottom: none;
}

.race-program__table tbody tr:hover {
  background-color: var(--color-warning-light);
}

.race-program__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: var(--space-6);
  color: var(--color-text-muted);
}

.race-program__empty p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
}
</style>
